module.exports = __webpack_public_path__ + "static/media/cash-for-used-car-rocklea.9657e5a1.png";